import {i18n} from '@/plugins/i18n'

export const shahkarInquiryStatus = {
     PENDING : 0,
     IS_MATCHED : 1,
     IS_NOT_MATCHED : 2,
}

export const shahkarInquiryStatusStr = {
    PENDING: i18n.t('shahkar_inquiry_types.pending'),
    IS_MATCHED: i18n.t('shahkar_inquiry_types.is_matched'),
    IS_NOT_MATCHED: i18n.t('shahkar_inquiry_types.is_not_matched'),
    CONFIRMED: i18n.t('shahkar_inquiry_types.confirmed'),
    REJECTED: i18n.t('shahkar_inquiry_types.rejected'),

    get(type) {
        let type_str = null;
        Object.keys(shahkarInquiryStatus).forEach(function (item, index) {
            if (shahkarInquiryStatus[item] === type) {
                type_str = shahkarInquiryStatusStr[item]
            }
        })

        return type_str
    }
}